export const documents = {
  description:
    "Drawings, procedures, and photos stored privately and traceable by audit event.",
  column: {
    document: "Document",
    size: "Size",
  },
  uploaded: "Uploaded",
  by: "by",
  download: "Download",
  caption: "Documents attached to {ownerType} {ownerId}",
  emptyTitle: "No documents here yet",
  emptyDescription:
    "Uploaded drawings, photos, and procedures will be listed for this reference.",
  deletedToast: "Document marked deleted",
  deletedToastDesc: "{name} (reason recorded in the audit trail)",
  document: "document",
  deleteTitle: "Delete {name}?",
  deleteDescription:
    "The record is kept for history; the file disappears from lists and downloads.",
  confirmDelete: "Confirm delete",
  reasonHint: "Required for the audit trail (minimum 3 characters).",
  filter: {
    attachedTo: "Attached to",
    reference: "Reference",
    referenceHint: "Letters, digits, dash, underscore.",
  },
  ownerType: {
    other: "General shop documents",
    customer: "Customer (by reference)",
    quote: "Quote (by reference)",
    job: "Job (by reference)",
    purchase_order: "Purchase order (by reference)",
    invoice: "Invoice (by reference)",
  },
  uploadCard: {
    title: "Upload a document",
    fileLabel: "File (PDF, PNG, JPEG, WEBP — max 10 MB)",
    uploading: "Uploading…",
    upload: "Upload",
    chooseFirst: "Choose a PDF, PNG, JPEG, or WEBP file first.",
    uploadedToast: "Document uploaded",
  },
};
